export default "__VITE_PUBLIC_ASSET__f9bc3384__"